import { IAppMenu, IServiceMenu } from 'hooks/useServiceMenuQuery'

export const sortMenu = (menuList: IAppMenu[] | IServiceMenu[]): IAppMenu[] | IServiceMenu[] => {
  return menuList.sort((a, b) => {
    if (!a.menuOrder) a.menuOrder = 0
    if (!b.menuOrder) b.menuOrder = 0
    return a.menuOrder < b.menuOrder ? -1 : 1
  })
}
